import bowser from "bowser";
import forOwn from "lodash/forOwn";

import constants from "../constants/RTMEmbed";

function addEvent(event, element, callback) {
    if (element.addEventListener) {
        element.addEventListener(event, callback);
    } else if (element.attachEvent) {
        element.attachEvent(`on${event}`, callback);
    } else {
        element[event] = callback; // eslint-disable-line no-param-reassign
    }
}

export default function BrowserNotSupported() {
    const script = document.getElementById("directlyRTMScript");
    const link = document.createElement("a");
    let baseUrl = "";

    link.href = script.src;
    baseUrl += link.protocol;
    baseUrl += "//";
    baseUrl += link.hostname;
    baseUrl += link.port && link.port !== 0 ? `:${link.port}` : "";

    const availableBrowsers = [
        {
            name: "Chrome",
            icon: "/widgets/rtm/images/chrome.jpg",
            url: "https://www.google.com/chrome/browser/",
            visible: true,
        },
        {
            name: "Edge",
            icon: "/widgets/rtm/images/edge.jpg",
            url: "https://www.microsoft.com/en-us/windows/microsoft-edge",
            visible: bowser.windows,
        },
        {
            name: "Firefox",
            icon: "/widgets/rtm/images/firefox.jpg",
            url: "https://www.mozilla.org/firefox",
            visible: true,
        },
        {
            name: "Safari",
            icon: "/widgets/rtm/images/safari.jpg",
            url: "https://support.apple.com/downloads/safari",
            visible: true,
        },
    ];
    const head = document.head || document.getElementsByTagName("head")[0];
    const wrapper = document.createElement("div");
    const container = document.createElement("div");
    const maximizedView = document.createElement("div");
    const headerContainer = document.createElement("div");
    const headerTitle = document.createElement("h1");
    const headerTitleText = document.createTextNode("Browser not supported");
    const askQuestionFormContainer = document.createElement("div");
    const minimizeContainer = document.createElement("div");
    const close = document.createElement("img");
    const firstMessageContainer = document.createElement("div");
    const firstMessageContent = document.createTextNode(
        "Oops! Unfortunately, your browser does not support our technology."
    );
    const secondMessageContainer = document.createElement("div");
    const secondMessageContent = document.createTextNode(
        "Please use the latest version of one of these browsers to continue:"
    );
    const browsersList = document.createElement("ul");
    const styleUrl = `${baseUrl}/widgets/rtm/style.css?v=${__webpack_hash__}`; // eslint-disable-line camelcase

    if (document.createStyleSheet) {
        const styleSheet = document.createStyleSheet("");
        let cssCode = `.directly-rtm-is-open{height:100%;overflow:hidden;position:fixed;width:100%}.directly-rtm{border:0;bottom:0;box-sizing:border-box;height:100%;margin:0;max-height:880px;max-width:100%;padding:0;position:fixed;right:0;-webkit-transform-origin:right bottom;-ms-transform-origin:right bottom;transform-origin:right bottom;width:100%;z-index:999999}.directly-rtm.is-maximizing{-webkit-animation:maximize 100ms forwards;animation:maximize 100ms forwards}.directly-rtm.is-minimizing{-webkit-animation:minimize 80ms forwards;animation:minimize 80ms forwards}.directly-rtm.is-minimized{height:152px;width:144px;padding:10px 0;-webkit-transform-origin:50% bottom;-ms-transform-origin:50% bottom;transform-origin:50% bottom}.directly-rtm.is-ask-form{min-height:200px;max-height:560px}.directly-rtm.is-hidden{display:none}.directly-rtm iframe{border:none;height:100%;width:100%}.browser-not-supported.directly-rtm{width:386px;height:400px;padding:0 0 10px;background:#F4F6F6;border: 1px solid #D5DADC;border-radius:10px 10px;right: 40px;position:fixed;font-family:"Open Sans",Helvetica,sans-serif}.browser-not-supported .message{background:#fff;font-size:14px;border-radius:20px 20px 20px 0;margin:15px 55px 15px 20px;padding:20px 15px 13px;border:1px solid #D5DADC;color:#2F4550}.browser-not-supported .browsers-list{margin:13px 0 0;padding:0;list-style:none;overflow:hidden}.browser-not-supported .browsers-list li{line-height:156%;text-decoration-line:underline;color:#1292DA;opacity:1;overflow:hidden;margin-bottom:8px;zoom:1;*display:block}.browser-not-supported .browsers-list a{color:#1292DA}.browser-not-supported .browsers-list a:hover{text-decoration:none}.browser-not-supported .browsers-list .safari{margin-bottom:0}.browser-not-supported .browsers-list .icon-container{width: 24px; margin-right:10px;float:left; text-align: center;}.browser-not-supported .ask-question-form-container{margin-top:38px}.browser-not-supported .header-container{border-radius:10px 10px 0 0;background:#fff;box-shadow:0 2px 0 rgba(0,0,0,0.03),0 1px 0 rgba(0,0,0,0.05);height:54px;position:relative;white-space:nowrap;z-index:100}.header-container.response-switcher-is-open{box-shadow:0 1px 0 #d5dadc}.header-container .menu,.header-container .minimize-container{height:100%;text-align:center;justify-content:center}.browser-not-supported .minimize-container img{margin-top:19px}.header-container .menu{border-right:1px solid #d5dadc;cursor:pointer;-webkit-box-flex:0;-webkit-flex:0 0 50px;-ms-flex:0 0 50px;flex:0 0 50px;height:100%;-webkit-transition:background 80ms linear;transition:background 80ms linear}.browser-not-supported .svg-icon{color:#a8b2b6;display:block;height:52px;margin:0 auto;width:15px}.header-container .menu:hover .svg-icon{opacity:.8}.header-container .menu.disabled{background:#abb5b9}.header-container .menu.disabled .svg-icon{color:#fff}.browser-not-supported .header-title{width: 293px;float:left;box-sizing:border-box;display:block;font-size:16px;font-weight:400;min-width:0;overflow:hidden;line-height: 30px;padding:0px 10px 0 20px}.browser-not-supported .minimize-container{width:61px;float:right;border:0;display:table;vertical-align:middle;border-left:1px solid #d5dadc}@-webkit-keyframes maximize{0%{opacity:0;-webkit-transform:scale(0.9);transform:scale(0.9)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes maximize{0%{opacity:0;-webkit-transform:scale(0.9);transform:scale(0.9)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes minimize{0%{opacity:0;-webkit-transform:scale(0.9);transform:scale(0.9)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes minimize{0%{opacity:0;-webkit-transform:scale(0.9);transform:scale(0.9)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@media (min-width: 668px){.directly-rtm{max-width:356px;padding:10px 10px 10px 0}.browser-not-supported.directly-rtm{max-width:386px}}`; // eslint-disable-line max-len
        if (bowser.msie && (bowser.version === 6 || bowser.version === 7)) {
            cssCode += `.browser-not-supported {position: absolute; top: expression(documentElement.scrollTop+(documentElement.clientHeight-this.clientHeight-40));} .browser-not-supported .header-title {padding-top: 14px;}`; // eslint-disable-line max-len
        }
        styleSheet.cssText = cssCode;
    } else {
        const cssLink = document.createElement("link");

        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.crossOrigin = "anonymous";
        cssLink.href = styleUrl;
        head.appendChild(cssLink);
    }

    browsersList.className = "browsers-list";

    forOwn(availableBrowsers, browser => {
        if (!browser.visible) return;

        const listElement = document.createElement("li");
        const anchor = document.createElement("a");
        const browserName = document.createTextNode(browser.name);
        const image = document.createElement("img");
        const imageContainer = document.createElement("div");

        anchor.href = browser.url;
        anchor.target = "_blank";
        anchor.appendChild(browserName);

        image.src = baseUrl + browser.icon;
        image.className = "icon";

        imageContainer.className = "icon-container";
        imageContainer.appendChild(image);

        listElement.className = browser.name.toLowerCase();
        listElement.appendChild(imageContainer);
        listElement.appendChild(anchor);

        browsersList.appendChild(listElement);
    });

    firstMessageContainer.className = "message";
    secondMessageContainer.className = "message";

    firstMessageContainer.appendChild(firstMessageContent);
    secondMessageContainer.appendChild(secondMessageContent);
    secondMessageContainer.appendChild(browsersList);

    close.src = `${baseUrl}/widgets/rtm/images/close.jpg`;
    minimizeContainer.className = "minimize-container";
    minimizeContainer.appendChild(close);
    addEvent("click", minimizeContainer, () => {
        wrapper.style.display = "none";
    });

    askQuestionFormContainer.className = "ask-question-form-container";
    askQuestionFormContainer.appendChild(firstMessageContainer);
    askQuestionFormContainer.appendChild(secondMessageContainer);

    headerContainer.className = "header-container";
    headerTitle.className = "header-title";

    headerTitle.appendChild(headerTitleText);
    headerContainer.appendChild(headerTitle);
    headerContainer.appendChild(minimizeContainer);

    maximizedView.className = "maximized-view is-ask-view";
    maximizedView.appendChild(headerContainer);
    maximizedView.appendChild(askQuestionFormContainer);

    container.className = "js-chat-container chat-container";
    container.appendChild(maximizedView);

    wrapper.className = "directly-rtm browser-not-supported";
    wrapper.appendChild(container);
    document.body.appendChild(wrapper);
    wrapper.style.display = "none";

    window[constants.NAMESPACE] = () => {
        wrapper.style.display = "block";
    };
}
